import { render, staticRenderFns } from "./UiTextArea.vue?vue&type=template&id=eb0bc060&scoped=true&"
import script from "./UiTextArea.vue?vue&type=script&lang=js&"
export * from "./UiTextArea.vue?vue&type=script&lang=js&"
import style0 from "./UiTextArea.vue?vue&type=style&index=0&id=eb0bc060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0bc060",
  null
  
)

export default component.exports